import React from "react";
import { Button, Dropdown, Form, Tabs, Tab, ToggleButton } from 'react-bootstrap';
import { context } from '../AppContext';
import ItemEditor from '../ItemEditor';
import HorizontalTabs from '../HorizontalTabs';

export default class ConfigExplorer extends React.Component {
    state = {
    };

    componentWillMount() {
    }

    render() {
        let sectionList = ["ControlGroups", "Controls", "BodiesOfWater", "Devices", "WaterFeatures", "Flows"];
            
        return (
            <HorizontalTabs 
                tabs={ sectionList
                    .filter((section) => this.props.config[section] ? true : false)
                    .map(section => {
                    return {
                        id: "section_" + section,
                        title: section + " (" + (this.props.config[section]?.length || 0) + ")",
                        content: (
                            <HorizontalTabs 
                                tabs={ this.props.config[section]?.map(sectionItem => {
                                    let prefix = "";
                                    if (section === "Controls") {
                                        prefix = this.props.config.ControlGroups.find(cg => cg.UUID === sectionItem.ControlGroupUUID)?.Name
                                    }
                                    return {
                                        id: sectionItem.UUID,
                                        title: prefix + " " + (sectionItem?.Name || "UNKNOWN"),
                                        content: (
                                            <ItemEditor
                                                schema={section}
                                                record={sectionItem}
                                            />
                                        )
                                    }

                                }) }
                            />
                        )
                    }

                }) }
            /> 
        );
    }
}

